import { axiosSwagger } from "@/axios";

export const state = {
    officeSummary: {
        loading: false,
        data: [],
        error: null,
    }
};

export const getters = {
    summaryData: (state) => state.officeSummary.data || [],
    isLoading: (state) => state.officeSummary.loading,
};

export const mutations = {
    setLoading: (state, loading) => {
        state.officeSummary.loading = loading;
    },
    setData: (state, data) => {
        state.officeSummary.data = data;
    },
    setError: (state, error) => {
        state.officeSummary.error = error;
    }
};

export const actions = {
    async readOfficeSummary({ commit }, campusId) {
        commit('setLoading', true);
        commit('setError', null);

        if (!campusId) {
            commit('setLoading', false);
            return [];
        }

        return await axiosSwagger
            .get(`/api/FileManager/OfficeFiles/Summary/${campusId}`)
            .then((response) => {
                commit('setLoading', false);
                commit('setData', response?.data || []);
                return response?.data;
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
                console.error("Error reading office files summary:", error);
                throw error;
            });
    }
};
